export default {

  data () {
    return {
      stateName: '',

    }
  },
  mounted () {
    this.stateName = this.$route.name

  },
  watch: {
    '$route' (to, from) {
      this.stateName = to.name
    }
  },
  methods: {
    showabouthydroware() {
      //FG - FOOF - After Cert - First Release (5) - flipped the order of parms msg and ttl
      var optionsToUse = {
        title: "About HydroWare",
        message: "Version: " + this.$hydrowareCommonJS.Version
      }
      this.$hydrowareCommonJS.displayPopupMessage(this, optionsToUse)
      /* CODE BELOW IS PRIOR TO CERTIFICATION
      this.$hydrowareCommonJS.displayPopupMessage(
        this, 
        "About HydroWare", //TITLE
        "Version: " + this.$hydrowareCommonJS.Version 
      );
      */
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/footer/footer.controller.js